<script>
import Layout from '@layouts/main'
import Filters from './filters'

export default {
  name: 'ReportView',
  metaInfo: {
    title: '',
  },
  components: {
    Layout,
    Filters,
    CurrentOilVolume: () => import('./CurrentOilVolume'),
    DrumsWithTheRemainder: () => import('./DrumsWithTheRemainder'),
    AverageOilUsageDuringATimePeriodByOilType: () =>
      import('./AverageOilUsageDuringATimePeriodByOilType'),
    PoorBattery: () => import('./PoorBattery'),
    CurrentVolumeAndSufficiencyOfOilByOilType: () =>
      import('./CurrentVolumeAndSufficiencyOfOilByOilType'),
    ToppingUpOil: () => import('./ToppingUpOil'),
    SupplyForecast: () => import('./SupplyForecast'),
    WorkshopsNotUsingAnyOil: () => import('./WorkshopsNotUsingAnyOil'),
    UnresponsiveTransmittersAndPlugs: () =>
      import('./UnresponsiveTransmittersAndPlugs'),
    CurrentUsageOfOilOnAMap: () => import('./CurrentUsageOfOilOnAMap'),
    OilUsageDuringATimePeriodByOilType: () =>
      import('./OilUsageDuringATimePeriodByOilType'),
    ShipmentMistakes: () => import('./ShipmentMistakes'),
    AvailabilityOfTransmittersInTheWorkshop: () =>
      import('./AvailabilityOfTransmittersInTheWorkshop'),
    InvalidMeasurement: () => import('./InvalidMeasurement'),
    OilVolumeChange: () => import('./OilVolumeChange'),
    MergedButNotInitializedPlugs: () =>
      import('./MergedButNotInitializedPlugs'),
  },
  data() {
    return {
      filters: null,
    }
  },
  computed: {
    name() {
      return this.$route.params.name
    },
  },
  methods: {
    setFilters(value) {
      this.filters = { ...value }
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="actionButton">
      <v-btn
        v-if="name !== 'CurrentUsageOfOilOnAMap' && name !== 'OilVolumeChange'"
        color="primary"
        @click="$refs.currentComponent.export()"
      >
        {{ $t('buttons__export') }}
      </v-btn>
      <filters
        :model-name="name"
        @set-filters="setFilters($event) & $refs.currentComponent.resetPage()"
        @clear-filters="setFilters($event) & $refs.currentComponent.clearFilters()"
      />
    </div>
    <component
      ref="currentComponent"
      :filters="filters"
      :is="name"
    />
  </Layout>
</template>
